<!-- <p>App component</p> -->
<!-- <div id="custom-splash" class="splash-screen" *ngIf="imageSrc">
  <img [src]="imageSrc" alt="Loading..." />
</div> -->
<router-outlet></router-outlet>
